import { Services } from "appworks/services/services";
import { Contract } from "appworks/utils/contracts/contract";
import { PartnerConnectSpinRequestPayload } from "partner-connect/integration/schema/partner-connect-spin-schema";
import { PartnerConnectManager } from "partner-connect/partner-connect-manager";
import { partnerConnectConnector } from "partner-connect/server/connectors/partner-connect-connector";

export function PartnerConnectCollectCommand(force: boolean = false): Contract<any> {
    if ((partnerConnectConnector.pendingCmds && partnerConnectConnector.pendingCmds[0] === "C" && !PartnerConnectManager.isHistoryMode()) || force) {
        const payload = new PartnerConnectSpinRequestPayload();
        payload.creditPerLine = Services.bet.getCreditPerLine();
        payload.creditSize = Services.bet.getCreditSize();
        payload.type = "collect";
        payload.cmd = "C";

        return new Contract((resolve) => {
            partnerConnectConnector.sendRequest(payload).then(() => resolve());
        });
    } else {
        return Contract.empty();
    }
}
